import React, {useEffect, useState} from 'react';
import {Col, Row} from 'reactstrap';
import {connect, useSelector} from "react-redux";
import {getStateByPath} from "../../../redux/selectors";

// components
import { showLoader} from "../../../components/loader/loader";

// actions
import {
    setForm,
    setApp,
    setItem,
    setUserIsAdmin,
    ADD_STATE,
    REMOVE_STATE,
    setCategory, setUdn, setMapConfig
} from "../../../redux/actions/generics/IndexedActions";
import {mapFunctions} from "../../../components/map/mapFunctions";
import HomeCategorySection from "./homeCategorySection/HomeCategorySection";
import HomeUdnSection from "./udnSection/HomeUdnSection";
import HomePlaceSection from "./placeSection/HomePlaceSection";



function HomeController(props) {
    const path = props.path || 'hotel/home';
    const componentState = useSelector(state => getStateByPath(state, path));
    const { loading, udn } = componentState?.data || false;
    const [googleConfig, setGoogleConfig] = useState(null );

    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        }
    }, []);

    useEffect(() => {
        if (props.app !== null)
            props.setApp(path, props.app);

        const _udn = localStorage.getItem('selectedUdn') !== '' ? JSON.parse(localStorage.getItem('selectedUdn')) : null
        if (_udn) {
            loadGoogleConfig( _udn );
            props.setUdn(path, _udn);
        }

        const userStorage = localStorage.getItem('userData')

        if (userStorage && userStorage !== 'undefined') {
            try {
                const user = JSON.parse(userStorage);
                if (user?.isAdmin) {
                    props.setUserIsAdmin(path, true)
                }
                else {
                    props.setUserIsAdmin(path, false)
                }

            } catch (e) {
                console.error(e);
            }
        }
    },[]);

    const loadGoogleConfig = ( _udn ) => {
        let _googleConfig = {}

        if (_udn?.id !== undefined){
            mapFunctions.loadMapConfig(_udn)
                .then(result => {
                    if (result?.data?.length > 0) {
                        let config = result?.data[0];
                        _googleConfig =  {
                            mapOptions: {
                                center: {
                                    lat: parseFloat(config?.latitude),
                                    lng: parseFloat(config?.longitude)
                                },
                                disableDefaultUI: false,
                                mapTypeControl: false,
                                rotateControl: false,
                                streetViewControl: false,
                                zoom: config.defaultZoom + 1,
                                minZoom: config.minZoom,
                                maxZoom: config.maxZoom + 3
                            },
                            overlay: {
                                udn: config.udnCode.toLowerCase(),
                                pto1: {
                                    lat: config.overlay1Lat,
                                    lng: config.overlay1Long
                                },
                                pto2: {
                                    lat: parseFloat(config.overlay2Lat),
                                    lng: parseFloat(config.overlay2Long)
                                }
                            },
                            bound: {
                                sw: {
                                    lat: parseFloat(config.bound2Lat),
                                    lng: parseFloat(config.bound2Long)
                                },
                                ne: {
                                    lat: parseFloat(config.bound1Lat),
                                    lng: parseFloat(config.bound1Long)
                                }
                            }
                        }

                        setGoogleConfig(_googleConfig);
                        props.setMapConfig(path, _googleConfig);
                    }

                })
                .catch(ex => {
                    console.log(ex);
                });
        }
    }


    return (
        <div>
            {loading && showLoader()}
            <Row>
                <Col md="6">
                    <HomeUdnSection path={path} />
                </Col>
                <Col md="6">
                    <HomePlaceSection path={path} />
                </Col>
            </Row>
            <Row>
                <Col md="12">
                    <HomeCategorySection path={path } />
                </Col>
            </Row>
        </div>
    );
}

const mapStateToProps = _ => ({
});

const mapActionsToProps = ({
    ADD_STATE,
    REMOVE_STATE,
    setApp,
    setCategory,
    setMapConfig,
    setUdn,
    setForm,
    setItem,
    setUserIsAdmin
});

export default connect(mapStateToProps, mapActionsToProps)(HomeController)

